import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-white py-6 px-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <h3 className="text-lg font-bold">{t("HOTEL_INFO")}</h3>
          <p>{t("ADDRESS")}</p>
          <p>{t("EMAIL1")}</p>
          <p>{t("HOTLINE")}</p>
        </div>
        <div>
          <h3 className="text-lg font-bold">{t("SOCIAL_MEDIA")}</h3>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/share/1AEeAWsP3C/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-blue-500 hover:underline"
            >
              f
            </a>
            <a href="#" className="text-2xl">
              📷
            </a>
            <a href="#" className="text-2xl">
              🎵
            </a>
          </div>
        </div>
      </div>
      <div className="mt-4 w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.5732564842235!2d105.6487803!3d10.4565167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310a6456d8b0f71b%3A0x7bdeef1ea238540d!2zS2jDoWNoIHPhu5FuIMSQ4bqjIFbGsMahbmcgMg!5e0!3m2!1svi!2s!4v1684302282540!5m2!1svi!2s"
          width="100%"
          height="300"
          style={{ border: "0" }}
          allowFullScreen
          loading="lazy"
          title="Location of ĐẾ VƯƠNG"
        />
      </div>
      <p className="text-center mt-4">© 2025 ĐẾ VƯƠNG </p>
    </footer>
  );
};

export default Footer;
